import { render, staticRenderFns } from "./ScoutRecommendedFooter.vue?vue&type=template&id=401285dc"
import script from "./ScoutRecommendedFooter.vue?vue&type=script&lang=js"
export * from "./ScoutRecommendedFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports